import { cn } from "@u/cn";
import { Lock, Plus, type LucideIcon } from "lucide-react";

type AddButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  /** Leading glyph. Defaults to `Plus` (the shared add affordance). */
  icon?: LucideIcon;
  /** Plan-gated: looks identical, but the glyph turns into a lock on hover. */
  locked?: boolean;
};

/**
 * Dashed "add" pill — single source for the `+ <thing>` affordance that was
 * hand-rolled identically across the tour + venue editors. Pass your own `icon`
 * to keep a context-specific glyph.
 */
export function AddButton({
  label,
  icon: Icon = Plus,
  locked = false,
  className,
  ...props
}: AddButtonProps) {
  return (
    <button
      type="button"
      className={cn(
        "group inline-flex items-center gap-1.5 rounded-full border border-dashed border-border px-3 py-1.5 text-sm text-muted-foreground transition hover:border-primary hover:text-foreground",
        className,
      )}
      {...props}
    >
      {locked ? (
        <>
          <Icon size={14} className="group-hover:hidden" />
          <Lock size={14} className="hidden group-hover:block" />
        </>
      ) : (
        <Icon size={14} />
      )}
      {label}
    </button>
  );
}
